import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { UserProvider } from '../user/user';

@Injectable()
export class GrupoProvider {
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;
  constructor(
    public http: HttpClient,
    public userProvider: UserProvider,
  ) {}

  getGruposPessoa(idPessoa, tipo) {
    return this.http
      .get<any>(this.baseUrl + '/grupo/get-grupos-pessoa', {
        params: { idPessoa: idPessoa, tipo: tipo },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getFotoReuniao(entidade, idReuniao) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/get-fotos', {
        entidade: entidade,
        idReuniao: idReuniao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  downloadPauta(idReuniao) {
    return this.http
      .get<any>(this.baseUrl + '/grupo/download-pauta', {
        params: {
          idReuniao: idReuniao,
        },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  removerImagem(id) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/remover-foto', {
        id: id,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getEsporadicos(idReuniao) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/get-esporadicos', {
        idReuniao: idReuniao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getOvelinhas() {
    return this.http.post<any>(this.baseUrl + '/grupo/reuniao-ovelinhas', {}).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getOvelinhasHistorico(idPessoa) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/reuniao-ovelinhas-historico', {
        idPessoa: idPessoa,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  checkIsMenorIdade(idPessoa) {
    return this.http
      .get<any>(this.baseUrl + '/grupo/check-is-menor-idade', {
        params: { idPessoa: idPessoa },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  check(idPessoa, entidade, idEntidade, observacao, idResponsavel, isCheckin, idReuniao) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/realizar-check', {
        idPessoa: idPessoa,
        entidade: entidade,
        idEntidade: idEntidade,
        observacao: observacao,
        idResponsavel: idResponsavel,
        isCheckin: isCheckin,
        idReuniao: idReuniao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getFamiliaresPresencaReuniao(idReuniao) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/get-familiares-presenca-reuniao', {
        idReuniao: idReuniao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  salvarPresencaOvelinhas(familiares, idReuniao) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/salvar-presenca-ovelinhas', {
        familiares: familiares,
        idReuniao: idReuniao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  checkBarcode(idPessoa, idReuniao) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/check-barcode', {
        idPessoa: idPessoa,
        idReuniao: idReuniao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getGruposGeral(filtro, tipoGrupo, regiao, dia, tipo, pag) {
    return this.http
      .get<any>(this.baseUrl + '/grupo/get-grupos-geral', {
        observe: 'response',
        params: {
          page: pag.currentPage,
          'per-page': '10',
          filtro: filtro,
          tipoGrupo: tipoGrupo,
          regiao: regiao,
          dia: dia,
          tipo: tipo,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          grupos: data.body,
          pagination: pag,
        };
      });
  }

  getParticipantesGeral(filtro, pag, idReuniao) {
    return this.http
      .get<any>(this.baseUrl + '/grupo/get-participantes-geral', {
        observe: 'response',
        params: {
          page: pag.currentPage,
          'per-page': '10',
          filtro: filtro.q,
          pessoa: filtro.pessoa,
          isResponsavel: filtro.isResponsavel,
          idReuniao: idReuniao,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };

        return {
          pessoas: data.body,
          pagination: pag,
        };
      });
  }

  updateFoto(base64, idReuniao, entidade) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/upload-foto', {
        foto: base64,
        idReuniao: idReuniao,
        entidade: entidade,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getGrupos(filtro, tipo) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/get-grupos', {
        filtro: filtro,
        tipo: tipo,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getGruposRede(idNodePai = '#', tipo = '', grupoMinisterio = '') {
    return this.http
      .post<any>(this.baseUrl + '/hierarquia/node-funcao', {
        nodeId: idNodePai,
        tipo: tipo,
        grupoMinisterio: grupoMinisterio,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getGruposTipos(tipo, filtroTipos) {
    return this.http.post<any>(this.baseUrl + '/grupo/grupo-tipos', { tipo: tipo, filtroTipos: filtroTipos }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getGrupoHierarquia() {
    return this.http.get<any>(this.baseUrl + '/grupo/get-grupo-hierarquia').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getGrupoCiclos() {
    return this.http.get<any>(this.baseUrl + '/grupo/get-grupo-ciclo').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  salvarGrupo(grupo) {
    return this.http.post<any>(this.baseUrl + '/grupo/salvar-grupo', grupo).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  buscarGrupo(id) {
    return this.http.post<any>(this.baseUrl + '/grupo/buscar-grupo', { id: id }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  buscarTodosGrupos(filtro, pag, idGrupo, tipo) {
    return this.http
      .get<any>(this.baseUrl + '/grupo/buscar-todos-grupos', {
        observe: 'response',
        params: {
          page: pag.currentPage,
          'per-page': '10',
          filtro: filtro,
          idGrupo: idGrupo,
          tipo: tipo,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          nome: data.body,
          pagination: pag,
        };
      });
  }

  solicitacaoDesligamento(idGrupo, idParticipante, tipo, tipoGrupo) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/solicitacao-desligamento', {
        idGrupo: idGrupo,
        idParticipante: idParticipante,
        tipo: tipo,
        tipoGrupo: tipoGrupo,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getTipoOcorrencia() {
    return this.http.get<any>(this.baseUrl + '/grupo/get-tipo-ocorrencias').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  removerParticipanteGrupo(idGrupo, idParticipante, idGrupoNovo, tipo) {
    return this.http
      .get<any>(this.baseUrl + '/grupo/remover-participante-grupo', {
        params: {
          id: idGrupo,
          idPessoa: idParticipante,
          idNovo: idGrupoNovo,
          tipo: tipo,
        },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getMigraParticipante(idGrupo, idParticipante) {
    return this.http
      .get<any>(this.baseUrl + '/grupo/get-migra-participante', {
        params: { idGrupo: idGrupo, idParticipante: idParticipante },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getValidaRegra(idGrupo, idParticipante) {
    return this.http
      .get<any>(this.baseUrl + '/grupo/get-valida-regra', {
        params: { idGrupo: idGrupo, idParticipante: idParticipante },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  buscarGrupoEndereco(id) {
    return this.http.post<any>(this.baseUrl + '/grupo/buscar-grupo-endereco', { id: id }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  alterarEnderecoGrupoPessoa(idGrupo, idPessoa) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/salvar-endereco-grupo-pessoa', {
        idGrupo: idGrupo,
        idPessoa: idPessoa,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getGruposRegiao() {
    return this.http.post<any>(this.baseUrl + '/grupo/grupo-regiao', {}).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getGrupoDetalhes(idGrupo) {
    return this.http.get<any>(this.baseAntigaUrl + '/grupo/' + idGrupo).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  confirmarPresenca(presenca, idGrupo, idProjeto) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/confirmar-presenca', {
        presenca: presenca,
        idGrupo: idGrupo,
        idProjeto: idProjeto,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getParticipantes(idReuniao) {
    return this.http.get<any>(this.baseAntigaUrl + '/reuniao/' + idReuniao + '/membros').map((data) => {
      if (!data.error) {
        return data.pessoas;
      } else {
        return false;
      }
    });
  }

  getVisitantes(idReuniao) {
    return this.http.get<any>(this.baseAntigaUrl + '/reuniao/' + idReuniao + '/visitantes').map((data) => {
      if (!data.error) {
        return data.pessoas;
      } else {
        return false;
      }
    });
  }

  getReuniao(idReuniao) {
    return this.http.get<any>(this.baseAntigaUrl + '/reuniao/' + idReuniao).map((data) => {
      if (!data.error) {
        return data.reuniao;
      } else {
        return false;
      }
    });
  }

  getReunioes(idGrupo) {
    return this.http.get<any>(this.baseAntigaUrl + '/grupo/' + idGrupo + '/reunioes').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  salvarReuniao(reuniao, idReuniao) {
    return this.http.post<any>(this.baseAntigaUrl + '/reuniao/' + idReuniao + '/resumo', reuniao).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  salvarStatus(idReuniao) {
    return this.http.post<any>(this.baseUrl + '/grupo/salvar-status', { idReuniao }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getTiposReuniao() {
    return this.http.get<any>(this.baseUrl + '/grupo/get-tipos-reuniao').map((data) => {
      return data;
    });
  }

  GrupoGeo(latitude, longitude, filtro) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/grupo-geo', {
        latitude: latitude,
        longitude: longitude,
        filtro: filtro,
      })
      .map((data) => {
        // if (!data.error) {
        //   return data;
        // } else {
        //   return data.message;
        // }

        return data;
      });
  }

  enviarSolicitacao(idPessoa, idGrupo) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/enviar-solicitacao', {
        idUsuario: idPessoa,
        idGrupo: idGrupo,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  criarReuniao(reuniao) {
    return this.http.post<any>(this.baseUrl + '/grupo/salvar-reuniao', reuniao).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  salvarParticipantes(dados) {
    return this.http.post<any>(this.baseUrl + '/grupo/presencas', dados).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  salvarParticipante(dados) {
    return this.http.post<any>(this.baseUrl + '/grupo/presenca', dados).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  removerParticipante(idGrupo, idParticipante) {
    return this.http.delete<any>(this.baseUrl + '/grupo/' + idGrupo + '/participante/' + idParticipante).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  removerVisitante(idGrupo, idVisitante) {
    return this.http.delete<any>(this.baseUrl + '/grupo/' + idGrupo + '/visitante/' + idVisitante).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  removerEsporadico(idEsporadico) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/remover-esporadico', {
        idEsporadico: idEsporadico,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getGrupoCargo() {
    return this.http.get<any>(this.baseUrl + '/grupo-cargo').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getGrupoCargoNovo(tipo) {
    return this.http.post<any>(this.baseUrl + '/grupo-cargo/get-by-tipo', { tipo: tipo }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getMensagem(idMensagem, idGrupo) {
    return this.http.get<any>(this.baseAntigaUrl + '/grupo/' + idGrupo + '/mensagem/' + idMensagem).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  criarParticipante(idGrupo, participante) {
    return this.http.post<any>(this.baseUrl + '/grupo/' + idGrupo + '/participante-regra', participante).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  checkGrupo(idPessoa, idGrupo) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/check-pessoa', {
        idPessoa: idPessoa,
        idGrupo: idGrupo,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getParticipantesGrupo(idGrupo) {
    return this.http.get<any>(this.baseAntigaUrl + '/grupo/' + idGrupo + '/participantes').map((data) => {
      if (!data.error) {
        return data.participantes;
      } else {
        return false;
      }
    });
  }

  criarVisitante(idGrupo, visitante) {
    return this.http.post<any>(this.baseUrl + '/grupo/' + idGrupo + '/visitante-regra', visitante).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  criarEsporadico(idReuniao, visitante) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/salvar-esporadico', {
        idReuniao: idReuniao,
        idEsporadico: visitante,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getVisitantesGrupo(idGrupo) {
    return this.http.get<any>(this.baseUrl + '/grupo/' + idGrupo + '/visitante').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  saveVisitanteGrupo(idGrupo, pessoa) {
    return this.http.post<any>(this.baseUrl + '/grupo/' + idGrupo + '/pessoa', pessoa).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getPauta(idReuniao) {
    return this.http.post<any>(this.baseUrl + '/grupo-reuniao/pauta', { id: idReuniao }).map((data) => {
      return data;
    });
  }

  grupoGrafico(idGrupo) {
    return this.http.post<any>(this.baseUrl + '/grupo/grupo-grafico', { idGrupo: idGrupo }).map((data) => {
      return data;
    });
  }

  frequenciaParticipante(idGrupo) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/frequencia-participante', {
        idGrupo: idGrupo,
      })
      .map((data) => {
        return data;
      });
  }

  savePauta(idReuniao, pauta) {
    return this.http
      .post<any>(this.baseUrl + '/grupo-reuniao/pauta', {
        id: idReuniao,
        pauta: pauta,
      })
      .map((data) => {
        return data;
      });
  }

  getGrupoCaixa(idGrupo) {
    return this.http
      .post<any>(this.baseUrl + '/grupo-caixa/get-grupo-caixa', {
        idGrupo: idGrupo,
      })
      .map((data) => {
        return data;
      });
  }

  getLancamentos(id, pag) {
    let params = new HttpParams()
      .set('expand', 'grupoCaixaItem,pessoaVinculo,lancamentoOfertas')
      .set('page', pag.currentPage)
      .set('per-page', '10')
      .set('id', id);

    return this.http
      .get<any>(this.baseUrl + '/grupo-caixa/get-grupo-caixa-lancamento', {
        observe: 'response',
        params: params,
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
        };
        return {
          lancamentos: data.body,
          pagination: pag,
        };
      });
  }

  getItensCaixa(tipo, idGrupo) {
    return this.http
      .post<any>(this.baseUrl + '/grupo-caixa/get-itens-caixa', {
        tipo: tipo,
        idGrupo: idGrupo,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  salvarCaixaTransferencia(lancamento) {
    return this.http
      .post<any>(this.baseUrl + '/grupo-caixa/salvar-transferencia', {
        isTransferencia: '1',
        valor: lancamento.valor.replace(/\D+/g, '') * -1,
        idGrupoCaixaItem: lancamento.item,
        idGrupoCaixa: lancamento.idGrupoCaixa,
        idPessoaVinculo: lancamento.idPessoa,
        dataLancamento: lancamento.data,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  salvarCaixaLancamento(tipo, lancamento) {
    return this.http
      .post<any>(this.baseUrl + '/grupo-caixa/salvar-lancamento', {
        valor: tipo == 'S' ? lancamento.valor.replace(/\D+/g, '') * -1 : lancamento.valor.replace(/\D+/g, ''),
        idGrupoCaixaItem: lancamento.item,
        idGrupoCaixa: lancamento.idGrupoCaixa,
        idPessoaVinculo: lancamento.idPessoa,
        dataLancamento: lancamento.data,
        descricao: lancamento.descricao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  removerLancamento(idLancamento) {
    return this.http
      .post<any>(this.baseUrl + '/grupo-caixa/remover-lancamento', {
        idLancamento: idLancamento,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  salvarEndereco(endereco) {
    return this.http.post<any>(this.baseUrl + '/grupo/endereco', endereco).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  salvarEnderecoGoogle(idEndereco, enderecoCompleto, idPais, objEndereco) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/endereco-google', {
        idEndereco: idEndereco,
        formatado: enderecoCompleto,
        idPais: idPais,
        objEndereco: objEndereco,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getGrupoHorario(id) {
    return this.http.post<any>(this.baseUrl + '/grupo/buscar-grupo-horario', { id: id }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  removerHorario(id) {
    return this.http.post<any>(this.baseUrl + '/grupo/remover-horario', { id: id }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  salvarHorario(horario) {
    return this.http.post<any>(this.baseUrl + '/grupo/salvar-horario', horario).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getHierarquia(idGrupo, tipo) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/get-estrutura', {
        idGrupo: idGrupo,
        tipoRaiz: tipo,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  removerHierarquia(idHierarquiaGrupoFuncao) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/remover-estrutura', {
        idHierarquiaGrupoFuncao: idHierarquiaGrupoFuncao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  salvarHierarquia(arrHierarquiaGrupoFuncao, idGrupo, idHierarquiaFuncao) {
    return this.http
      .post<any>(this.baseUrl + '/grupo/salvar-estrutura', {
        arrHierarquiaGrupoFuncao: arrHierarquiaGrupoFuncao,
        idGrupo: idGrupo,
        idHierarquiaFuncao: idHierarquiaFuncao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  criarFeedback(feedback) {
    return this.http.post<any>(this.baseUrl + '/grupo/criar-feedback', feedback).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  gerenciarSolicitacoes(idGrupo, filtro) {
    return this.http.post<any>(this.baseUrl + '/grupo/gerenciar-solicitacoes', { idGrupo, filtro }).map((data) => {
      return !data.error ? data : false;
    });
  }

  atualizarStatus(idSolicitacao) {
    return this.http.post<any>(this.baseUrl + '/grupo/atualizar-status', {idSolicitacao: idSolicitacao}).map((data) => {
      return !data.error ? data : false; 
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/grupo/grupo.ts